import type { QuotationDocumentData } from '@/quotation/document/types';
import { getLabels } from '@/quotation/document/labels';

interface Props { data: QuotationDocumentData }

interface TermRowProps { label: string; value: string }
function TermRow({ label, value }: TermRowProps) {
  return (
    <div className="flex gap-3 py-1.5 border-b border-neutral-100 last:border-b-0">
      <span className="text-sm text-neutral-400 shrink-0 w-36 pt-px">{label}</span>
      <span className="text-sm text-neutral-800 leading-relaxed">{value}</span>
    </div>
  );
}

export default function HtmlDocTerms({ data }: Props) {
  const L = getLabels(data.documentLocale);
  const hasTerms =
    data.paymentTerms || data.incoterm || data.namedPlace || data.leadTime ||
    data.remarks || data.specialRequirements;

  if (!hasTerms) return null;

  return (
    <div className="px-8 md:px-12 mt-7">
      <p className="text-xs font-extrabold text-ink-700 uppercase tracking-widest mb-3">
        {L.paymentTerms} & {L.incoterm}
      </p>
      <div>
        {data.paymentTerms && (
          <TermRow label={L.paymentTerms} value={data.paymentTerms} />
        )}
        {data.incoterm && (
          <TermRow label={L.incoterm} value={data.incoterm} />
        )}
        {data.namedPlace && (
          <TermRow label={L.namedPlace} value={data.namedPlace} />
        )}
        {data.leadTime && (
          <TermRow label={L.leadTime} value={data.leadTime} />
        )}
        {data.specialRequirements && (
          <TermRow label={L.specialRequirements} value={data.specialRequirements} />
        )}
        {data.remarks && (
          <TermRow label={L.remarks} value={data.remarks} />
        )}
      </div>
    </div>
  );
}